import request from '@/utils/request'

export function getList(data) {
  return request({
    url: `/payload?description=${data}`,
    method: 'get'
  })
}

export function verify(pbKey) {
  return request({
    url: '/public/id/' + pbKey,
    method: 'get'
  })
}

export function createPayload(data) {
  return request({
    url: '/payload',
    method: 'post',
    // config: { headers: { 'Content-Type': 'multipart/form-data' }},
    data
  })
}

export function updatePayload(id, data) {
  return request({
    url: `/payload/${id}`,
    method: 'put',
    // config: { headers: { 'Content-Type': 'multipart/form-data' }},
    data
  })
}

export function deletePayload(id) {
  return request({
    url: `/payload/${id}`,
    method: 'delete'
  })
}

export function deleteBulkPayload(data) {
  return request({
    url: `/payload/bulkDelete`,
    method: 'delete',
    data
  })
}

export function revokeCertificate(id) {
  return request({
    url: `/payload/revoke/${id}`,
    method: 'post'
  })
}

export function renewCertificate(id, data) {
  return request({
    url: `/payload/renew/${id}`,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/payload.js